import React, { useState, useEffect } from "react";
import { useWeb3 } from "../context/Web3Context";
import { getEthersProvider } from "../web3/provider";
import { getPurchase, getScnToken, getCoreDex, getCoreToken, getCoreMining } from "../web3/contracts";
import { shortAddress } from "../utils/format";
import Loader from "./common/Loader";

// Only the owner/admin of ANY managed contract may use the panel.
// Reads owner()/admin() from each contract and matches the connected wallet.
export default function AccessGuard({ children }) {
  const { account, disconnect } = useWeb3();
  const [status, setStatus] = useState("checking"); // checking | allowed | denied

  useEffect(() => {
    let cancelled = false;
    if (!account) { setStatus("checking"); return; }

    (async () => {
      setStatus("checking");
      const p = getEthersProvider();
      // Owner-only access. Admins are NOT allowed into the panel.
      const calls = [
        () => getPurchase(p).owner(),
        () => getScnToken(p).owner(),
        () => getCoreDex(p).owner(),
        () => getCoreToken(p).owner(),
        () => getCoreMining(p).owner(),
      ];
      const results = await Promise.allSettled(calls.map((f) => f()));
      if (cancelled) return;

      const authorized = results
        .filter((r) => r.status === "fulfilled" && r.value)
        .map((r) => r.value.toLowerCase());

      setStatus(authorized.includes(account.toLowerCase()) ? "allowed" : "denied");
    })();

    return () => { cancelled = true; };
  }, [account]);

  if (status === "checking") {
    return (
      <main className="app-content">
        <Loader text="Verifying admin access" fullscreen={false} />
      </main>
    );
  }

  if (status === "allowed") return children;

  return (
    <main className="app-content">
      <div className="card center fade-up" style={{ marginTop: 40 }}>
        <div style={{ fontSize: 40, marginBottom: 8 }}>🔒</div>
        <h2 className="card-title">Access Restricted</h2>
        <p className="muted">
          This panel is limited to the contract <strong>owner</strong> wallet only.
        </p>
        <p className="muted" style={{ fontSize: 13 }}>
          Connected as <strong>{shortAddress(account)}</strong> — not authorized.
        </p>
        <button className="btn btn-secondary btn-block mt-4" onClick={disconnect}>
          Disconnect &amp; switch wallet
        </button>
      </div>
    </main>
  );
}
